"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExperienceVoucher = void 0;
const isExperienceVoucher = (voucher) => {
    return (('orderItem' in voucher && !!voucher.orderItem) ||
        ('basketItem' in voucher && !!voucher.basketItem));
};
exports.isExperienceVoucher = isExperienceVoucher;
